import { X } from 'lucide-react';

export default function FilterChipBar({ filters, onRemove, onClear }) {
  const entries = Object.entries(filters).filter(([, v]) => v);
  if (entries.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {entries.map(([key, val]) => (
        <span
          key={key}
          className="inline-flex items-center gap-1 rounded-full bg-accent-soft px-2.5 py-0.5 text-xs text-accent"
        >
          <span className="font-medium">{key}:</span> {val.label || val}
          <button
            type="button"
            onClick={() => onRemove(key)}
            className="ml-0.5 rounded-full p-0.5 hover:bg-accent/20"
          >
            <X size={10} strokeWidth={2} />
          </button>
        </span>
      ))}
      {entries.length > 1 && (
        <button
          type="button"
          onClick={onClear}
          className="text-[10px] text-text-dim hover:text-text"
        >
          Clear all
        </button>
      )}
    </div>
  );
}
